<template>
	<Content style="padding: 15px;">
		<SwitchServer/>
	</Content>
</template>

<script>
	import SwitchServer from '../../components/SwitchServer.vue'
	export default {
		name: 'ManageDomain',
		components: {
			SwitchServer
		},
	}
</script>

<style>

</style>
